import sdl from '@jds/react-generated-sdl/JDSFAB';
import type { JDSFABProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, FABProps } from '../logic';

const Component = (props: FABProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { show = true, extend = true, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { show, extend, ...rest },
    'JDSFAB',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FAB = withLogic(Component) as React.FC<FABProps> & { slotName?: string };

FAB.displayName = 'FAB';
FAB.slotName = 'jdsfab';

export { FAB, type JDSFABProps };
